export default "__VITE_ASSET__Neu6t232__"